import React from "react";
import { objToFormData } from "../../../helpers/FormHelper";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { createUsernameStyle } from "../../../actions/mine_craft/usernameStylesActions";
import { setNewParams, setNewError } from "../../../store/mine_craft/usernameStylesSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const dispatch = useAppDispatch();
  const newParams = useAppSelector(state => state.mineCraft.usernameStyles.newParams);
  const error = useAppSelector(state => state.mineCraft.usernameStyles.newError);

  let params: any = { ...newParams };

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };

    const rules     = {};
    const formData  = objToFormData(data, rules);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createUsernameStyle(data));

    if (createUsernameStyle.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-skin'>
        <h6 className="v-content-label">Create Username Style</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
